import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { MarvDateService, MarvValidatorsService } from '@marv/services';

@Pipe({
    name: 'epochToString'
})
export class EpochToStringPipe implements PipeTransform {

    constructor(){}

    transform(value: unknown, ...args: unknown[]): string {
        let dateStr = '';
        let format = args[0]?.toString() || 'DD/MM/YYYY';
        if(value && MarvValidatorsService.isInteger(value)){
            let date = MarvDateService.ToDate(parseInt(value.toString()));
            if(date){
                dateStr = moment(date).format(format);
            }
        }
        return dateStr;
    }

}
